import axios from 'axios';
import { REACT_APP_API } from '../../config';

export default async function createMeliPublication(data) {
  
  try {
    return await axios.post(`${REACT_APP_API}/publications/meli/publicate`, data);
  } catch (error) {
    // Si vuelve un error con mensaje mensaje del backend, se usa ese mensaje
    if(error?.response?.data?.message) error.message = error.response.data.message;
    throw error;
  }

}
